class BeforeAfterSlider {
  constructor(el) {
    this.el = el;
    this.frame = el.querySelector('.ba-slider__frame');
    this.before = el.querySelector('.ba-slider__image--before');
    this.divider = el.querySelector('.ba-slider__divider');
    this.range = el.querySelector('.ba-slider__range');

    if (!this.frame || !this.before || !this.divider || !this.range) return;

    this.setPosition(this.range.value);

    this.range.addEventListener('input', (event) => {
      this.setPosition(event.target.value);
    });

    // Let people drag directly on the image, not just the range track
    this.frame.addEventListener('pointerdown', (event) => this.startDrag(event));
  }

  setPosition(value) {
    const percent = Math.min(100, Math.max(0, Number(value)));
    this.before.style.clipPath = `inset(0 ${100 - percent}% 0 0)`;
    this.divider.style.left = `${percent}%`;
    this.range.value = percent;
  }

  startDrag(event) {
    this.updateFromPointer(event);
    const move = (moveEvent) => this.updateFromPointer(moveEvent);
    const stop = () => {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', stop);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', stop);
  }

  updateFromPointer(event) {
    const rect = this.frame.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const percent = (x / rect.width) * 100;
    this.setPosition(percent);
  }
}

function initBeforeAfterSliders() {
  document.querySelectorAll('[data-ba-slider]').forEach((el) => {
    if (el.dataset.baInitialized) return;
    el.dataset.baInitialized = 'true';
    new BeforeAfterSlider(el);
  });
}

document.addEventListener('DOMContentLoaded', initBeforeAfterSliders);
document.addEventListener('shopify:section:load', initBeforeAfterSliders);